<p>
    ImgSigner is a native Windows app that uses the .NET STS library to interface with your instance. The primary purpose of this application is to give individual
    users the ability to upload packages, sign payloads, and perform various other tasks without writing a script or logging into the web console.
</p>

<div class="buffer"></div>
<hr />
<h1>Settings</h1>
<div class="warn">
    <mat-icon class="alert-icon" svgIcon="alert-circle"></mat-icon>
    Settings are saved when the window is closed.
</div>

<div class="buffer"></div>

<div class="code">

    <h3>STS Instance URL</h3>
    <p>Enter the URL of your STS instance here.</p>

    <h3>Credentials</h3>
    <p>Enter your user API Id and API key to connect to the server.</p>

    <h3>Updates</h3>
    <p>Select whether to check for updates to the application when it starts. You can also check by clicking <button mat-stroked-button>Check Now</button></p>

    <h3>Uploads</h3>
    <p>Enter the maximum number of tasks to run in parallel while uploading files. Usually 10-20 is a good number depending on your system's resources.</p>
</div>

<div class="buffer"></div>
<hr />
<h1>Select Signing Key</h1>
<div class="code">
    <p>This is the key pair you will use to sign payloads. The app looks in the user's personal store on their machine. The key you select is automatically loaded in
        subsequent launches of the app.
    </p>
</div>

<div class="buffer"></div>
<hr />
<h1>Pending Transfers</h1>
<div class="code">
    <p>In this section you can upload, sign, and reject pending transfers. Double-click an item in the list to see its hash and internal Id.</p>

    <h3>Upload</h3>
    <p>
        One or more files may be uploaded at once. When you select multiple files they will be uploaded one at a time, although each file will be broken into chunks and
        uploaded in parallel. A SHA-256 hash is computed for each file before the upload begins. If you attempt to cancel the upload during the hashing phase it will cancel
        after hashing completes. If you attempt to cancel during the upload phase it will take a minute to cancel all upload tasks on the client side while the server side
        will cancel immediately. Once the "Rebuilding and Scanning" phase is reached the operation can no longer be cancelled.
    </p>

    <h3>Signing</h3>
    <p>
        You must have a signing key selected in order to sign a payload. You may select one or more payloads from the list to sign at once. If you've already signed
        a payload an error will be returned stating it failed to sign. If you'd like to remove all payloads that you've already signed select the "Show unsigned only"
        checkbox to filter the list.
    </p>

    <h3>Reject</h3>
    <p>
        You may select one or more payloads from the list to reject at once.
    </p>
</div>